import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import Body from "src/components/common/Body";
import { RefProps } from "src/components/common/ImageModal";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import ImageModal from "src/components/common/ImageModal";
import List from "src/components/common/List";
import VideoBox from "src/components/common/VideoBox";
import DetailDashBox from "src/components/notice/DetailDashBox";
import NoticeDetailInfo from "src/components/notice/NoticeDetailInfo";
import SVG from "src/utils/SVG";
import styled, { css } from "styled-components";
import { pcDetailSliderArrowStyles, pcModalSliderStyles, pcModalBackgroundStyles } from "src/styles/sliderStyles";
import BottomModal from "../../components/common/BottomModal";
import SelectItem from "../../components/filter/SelectItem";
import {
  useDeleteNoticeMutation,
  useGetImportantNoticeCountQuery,
  useGetNoticeDetailQuery,
  useGetNoticeMutation,
  useModifyNoticeMutation,
} from "../../api/noticeAPI";
import NoticeCommentItem from "../../components/as/NoticeCommentItem";
import NoticeCommentInput from "../../components/as/NoticeCommentInput";
import { useAppSelector } from "../../store/actions/action";
import { shallowEqual, useDispatch } from "react-redux";
import { setModifyDataInit } from "../../store/reducers/modifyReduce";
import { setNoticeDataInit } from "../../store/reducers/noticeReduce";
import { setOnFocusReduce, setWriteNameReduce } from "../../store/reducers/noticeDetailReduce";
import { BLOCKED_USER, SOS_NOTICE_LIST, sosListSet } from "../../utils/sosFunc";
import { buildNoticeDeleteConfirmMessage } from "../../utils/noticeDeleteConfirm";

const initSettingList = ["중요공지 설정", "수정", "삭제"];

function noticeDetail() {
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const slider1 = React.useRef(null);
  const slider2 = React.useRef(null);

  // PC/모바일 반응형 상태
  const [isMobile, setIsMobile] = useState(true);

  // PC/모바일 반응형 감지
  const checkMobile = useCallback(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  useEffect(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [checkMobile]);

  const [getNotice] = useGetNoticeMutation();
  const [modifyNotice] = useModifyNoticeMutation();
  const [deleteNotice] = useDeleteNoticeMutation();
  const settingRef = React.useRef<RefProps>(null);
  const [settingList, setSettingList] = useState(initSettingList);
  const param = useParams();
  const noticeQuery = useGetNoticeDetailQuery(param.notice_idx);
  const [noticeData, setNoticeData] = useState<ModifyNotice>();
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const [imageSlider, setImageSlider] = useState<Slider | null>(null);
  const [changeSlide, setChangeSlide] = useState(false);
  const getImportNotiCount = useGetImportantNoticeCountQuery({});

  const [deletedPage, setDeletedPage] = useState(false);

  useEffect(() => {
    if (slider1.current !== null && slider2.current !== null) {
      setNav1(slider1.current);
      setNav2(slider2.current);
    }
  }, [noticeData]);

  // 삭제된 페이지 리스트로 이동
  const deletedModalRef = React.useRef<RefProps>(null);
  useEffect(() => {
    noticeQuery.data && setNoticeData(noticeQuery.data);
  }, [noticeQuery]);

  const confirmDeleted = () => {
    if (deletedModalRef.current) deletedModalRef.current.modalClose();
    navigate("/notice-list/");
  };

  useEffect(() => {
    let temp = [...initSettingList];
    if (noticeData?.important_yn == "Y") {
      temp[0] = "중요공지 해제";
    } else {
      temp[0] = "중요공지 설정";
    }
    if (noticeData?.vmd_id != userInfo.user_id) {
      temp = temp.slice(0, 1);
    }
    ////////////////////SOS
    userInfo.user_id == "m1" && temp.push("신고");
    userInfo.user_id == "m1" && temp.push("차단");

    setSettingList(temp);
  }, [noticeData]);

  useEffect(() => {
    if (param.notice_idx) {
      getNotice(param.notice_idx).then((res: any) => setNoticeData(res.data));
    }
  }, [param.notice_idx]);

  // images slide options
  const setImgSlide1 = {
    ref: slider1,
    asNavFor: nav2,
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !isMobile,
    cssEase: "ease-out",
  };

  const setImgSlide2 = {
    ref: slider2,
    asNavFor: nav1,
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !isMobile,
    cssEase: "ease-out",
  };
  const settings = {
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "ease-out",
  };

  const imageModalRef = React.useRef<RefProps>(null);
  const openImageModal = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (imageModalRef.current) imageModalRef.current.modalOpen();
  };

  const cmtImgModalRef = React.useRef<RefProps>(null);
  const [cmtView, setCmtView] = useState({
    cmtType: "parent",
    cmtIdx: 0,
    cmtchildIdx: 0,
    imgIdx: 0,
  });

  const clickCmtImages = (e: React.MouseEvent<HTMLLIElement>) => {
    // console.log(e);
    setCmtView({
      ...cmtView,
      cmtType: String(e.currentTarget.dataset.cmtType),
      cmtIdx: Number(e.currentTarget.dataset.cmtIdx),
      cmtchildIdx: Number(e.currentTarget.dataset.cmtchildIdx),
      imgIdx: Number(e.currentTarget.dataset.imgIdx),
    });
    imageSlider?.slickGoTo(Number(e.currentTarget.dataset.imgIdx));
    setChangeSlide(true);
  };

  useEffect(() => {
    if (changeSlide) {
      if (cmtImgModalRef.current) cmtImgModalRef.current.modalOpen();
    }
    setChangeSlide(false);
  }, [changeSlide]);

  function back() {
    // navigate("/notice-list/");
    navigate(-1);
  }

  const deleteAndMove = async () => {
    await deleteNotice(param.notice_idx);
    settingRef.current && settingRef.current.modalClose();
    navigate("/notice-list", { replace: true });
  };
  useEffect(() => {
    dispatch(setNoticeDataInit());
    dispatch(setModifyDataInit());
    dispatch(setOnFocusReduce(false));
    dispatch(setWriteNameReduce(["", ""]));
  }, []);

  const onSettingClick = (e: any) => {
    const clickedName = e.target.textContent;
    const index = settingList.indexOf(clickedName);
    switch (index) {
      case 0:
        getImportNotiCount.refetch();
        if (noticeData?.important_yn == "N" && getImportNotiCount.data?.count >= 5) {
          alert("중요공지는 최대 5개까지 설정 가능합니다.\n다른 공지의 중요공지 해제 후 설정해주세요.");
        } else {
          const form = new FormData();
          form.append("important_yn", noticeData?.important_yn == "Y" ? "N" : "Y");
          modifyNotice({ notice_idx: param.notice_idx, data: form })
            .then(() => {
              getNotice(param.notice_idx).then((res: any) => setNoticeData(res.data));
            })
            .then(() => getImportNotiCount.refetch());
        }
        settingRef.current && settingRef.current.modalClose();
        break;
      case 1:
        navigate("/notice-register/" + param.notice_idx);
        settingRef.current && settingRef.current.modalClose();
        break;
      case 2:
        if (window.confirm(buildNoticeDeleteConfirmMessage(noticeData?.executeCount))) {
          deleteAndMove();
        } else {
          settingRef.current && settingRef.current.modalClose();
        }
        break;
      ////////////////////SOS
      case 3:
        if (window.confirm("해당 공지를 신고하시겠습니까?")) {
          sosListSet(SOS_NOTICE_LIST, param.notice_idx);
          settingRef.current && settingRef.current.modalClose();
          navigate("/notice-list", { replace: true });
        } else {
          settingRef.current && settingRef.current.modalClose();
        }
        break;
      case 4:
        if (window.confirm("해당 사용자를 차단하시겠습니까?")) {
          sosListSet(BLOCKED_USER, noticeQuery.data.vmd_id);
          settingRef.current && settingRef.current.modalClose();
          navigate("/notice-list", { replace: true });
        } else {
          settingRef.current && settingRef.current.modalClose();
        }
        break;
      default:
        break;
    }
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => back()}>
            <span className="hidden">공지 상세</span>
          </Button>
        </div>
        {userInfo.user_type == "E" && (
          <div className="btn-box">
            <IconButton btnName="메뉴더보기" className="more" onClick={() => settingRef?.current?.modalOpen()}>
              <SVG name="more" />
            </IconButton>
          </div>
        )}
      </header>

      <Body type="detail">
        <ResponsiveContainer $isMobile={isMobile}>
          {noticeData && (
            <>
              {/* PC: 2컬럼 레이아웃 상단 영역 */}
              <MainContentArea $isMobile={isMobile}>
                {/* 이미지 슬라이더 영역 */}
                <ImageSection $isMobile={isMobile}>
                  <ImgSlide $isMobile={isMobile}>
                    <Slider {...setImgSlide1}>
                      {noticeData &&
                        noticeData.images.map((value: Image, index: number) => (
                          <div onClick={openImageModal} key={index}>
                            <div className="img-box detail-slide">
                              {value.ext === "mp4" || value.ext === "mov" ? (
                                <VideoBox controls vimeoId={value.img_url} />
                              ) : (
                                <img src={imageServerIp + value.img_url} alt={value.img_name} />
                              )}
                            </div>
                          </div>
                        ))}
                    </Slider>
                  </ImgSlide>
                </ImageSection>

                {/* 상세 정보 영역 */}
                <InfoSection $isMobile={isMobile}>
                  <NoticeDetailInfo noticeData={noticeData} />

                  {noticeData.execute_stores.length > 0 && (
                    <DetailDashBox
                      noticeId={noticeData.notice_idx}
                      userInfo={userInfo}
                      executeCount={noticeData.executeCount}
                      executeStore={noticeData.executeList}
                    />
                  )}

                  {userInfo.user_type != "E" &&
                    noticeData.execute_stores.find((store) => store.store_id == userInfo.user_id) &&
                    !noticeData.executeList.find((store) => store.store_id == userInfo.user_id) && (
                      <ButtonBox $isMobile={isMobile}>
                        <Button
                          variant="contained"
                          br="round"
                          onClick={() => {
                            navigate("/fulfill-Register/" + param.notice_idx);
                          }}
                        >
                          이행 등록
                        </Button>
                      </ButtonBox>
                    )}
                </InfoSection>
              </MainContentArea>

              {/* 댓글 영역 */}
              <CommentWrap $isMobile={isMobile}>
                <CommentList>
                  <p className="title">댓글 {noticeData.comment_count > 0 ? noticeData.comment_count : ""}</p>
                  <List pd="0" itemPd="20px 0">
                    <NoticeCommentItem commentList={noticeData.comments} onClick={clickCmtImages} />
                  </List>
                </CommentList>
                <NoticeCommentInput noticeData={noticeData} />
              </CommentWrap>
            </>
          )}
        </ResponsiveContainer>
      </Body>

      <BottomModal modalTitle="설정" ref={settingRef}>
        <List pd="0 15px">
          <SelectItem onClick={(e) => onSettingClick(e)} itemList={settingList} />
        </List>
      </BottomModal>

      <ImageModal ref={imageModalRef}>
        <ModalImgSlide>
          <StyledSlider {...setImgSlide2}>
            {noticeData?.images &&
              noticeData.images.length > 0 &&
              noticeData.images.map((value: Image, index: number) => {
                return (
                  <div className="img-box" key={index}>
                    {value.ext === "mp4" || value.ext === "mov" ? (
                      <VideoBox
                        controls
                        playAllow
                        vimeoId={value.img_url}
                        // src={imageServerIp + v.img_url}
                      />
                    ) : (
                      <img src={imageServerIp + value.img_url} alt={value.img_origin_name} />
                    )}
                  </div>
                );
              })}
          </StyledSlider>
        </ModalImgSlide>
      </ImageModal>

      <ImageModal ref={cmtImgModalRef}>
        <ModalImgSlide>
          <StyledSlider ref={(slider: Slider | null) => setImageSlider(slider)} {...settings}>
            {cmtView.cmtType === "parent"
              ? noticeData?.comments &&
                noticeData.comments.length > 0 &&
                noticeData.comments[cmtView.cmtIdx].images.length > 0 &&
                noticeData.comments[cmtView.cmtIdx].images.map((v: any, k: number) => {
                  return (
                    <div className="img-box" key={k}>
                      {v.ext === "mp4" || v.ext === "mov" ? (
                        <VideoBox
                          controls
                          playAllow
                          vimeoId={v.img_url}
                          // src={imageServerIp + v.img_url}
                        />
                      ) : (
                        <img src={imageServerIp + v.img_url} alt={v.img_origin_name} />
                      )}
                    </div>
                  );
                })
              : noticeData?.comments &&
                noticeData.comments.length > 0 &&
                noticeData.comments[cmtView.cmtIdx].childComments[cmtView.cmtchildIdx].images.length > 0 &&
                noticeData.comments[cmtView.cmtIdx].childComments[cmtView.cmtchildIdx].images.map((v: any, k: number) => {
                  return (
                    <div className="img-box" key={k}>
                      {v.ext === "mp4" || v.ext === "mov" ? (
                        <VideoBox
                          controls
                          playAllow
                          vimeoId={v.img_url}
                          // src={imageServerIp + v.img_url}
                        />
                      ) : (
                        <img src={imageServerIp + v.img_url} alt={v.img_origin_name} />
                      )}
                    </div>
                  );
                })}
          </StyledSlider>
        </ModalImgSlide>
      </ImageModal>
    </>
  );
}

// PC/모바일 반응형 컨테이너
const ResponsiveContainer = styled.div<{ $isMobile: boolean }>`
  padding: ${({ $isMobile }) => ($isMobile ? "0" : "24px")};
`;

// 메인 콘텐츠 영역 (PC: 2컬럼, 모바일: 1컬럼)
const MainContentArea = styled.div<{ $isMobile: boolean }>`
  display: ${({ $isMobile }) => ($isMobile ? "block" : "flex")};
  gap: ${({ $isMobile }) => ($isMobile ? "0" : "32px")};
  align-items: stretch;
`;

// 이미지 섹션
const ImageSection = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
    width: 100%;
  `
      : `
    flex: 1;
    min-width: 0;
  `}
`;

// 상세 정보 섹션
const InfoSection = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
    width: 100%;
  `
      : `
    flex: 1;
    min-width: 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
  `}
`;

const ImgSlide = styled.div<{ $isMobile: boolean }>`
  overflow: hidden;
  height: auto;
  background-color: #fff;

  ${({ $isMobile }) =>
    !$isMobile &&
    css`
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    height: 100%;
    position: relative;

    .img-box.detail-slide {
      height: 100vh;
      max-height: calc(100vh - 200px);
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    ${pcDetailSliderArrowStyles}

    ${/* dots 위치 조정 및 스타일 - 이미지 위에 표시 */ ""}
    .slick-dots {
      bottom: 16px;
      z-index: 10;
    }

    .slick-dots li button:before {
      border: none;
      background-color: rgba(255, 255, 255, 0.5);
    }

    .slick-dots li.slick-active button:before {
      border: none;
      background-color: #fff;
    }

    ${/* 슬라이더 영역 이미지 꽉 차게 */ ""}
    .slick-slider,
    .slick-list,
    .slick-track,
    .slick-slide,
    .slick-slide > div {
      height: 100%;
    }

    .slick-slide > div > div {
      height: 100%;
    }
  `}
`;

const ModalImgSlide = styled.div`
  height: 100%;
  background: #ccc;
  ${pcModalBackgroundStyles}
`;

const StyledSlider = styled(Slider)`
  .slick-track {
    height: 100%;
  }
  .slick-slide {
    height: 100%;
    ${({ theme }) => theme.flexBox.flexMixin("column", "center", "center")}
    > div {
      width: 100%;
      height: auto;
      overflow-y: scroll;
    }
    .img-box {
      padding-top: 0;
      text-align: center;
      > img {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
      > .video-wrap {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
    }
  }
  .slick-list {
    background: rgba(0, 0, 0, 0.5);
  }

  ${pcModalSliderStyles}
`;

const ButtonBox = styled.div<{ $isMobile: boolean }>`
  ${({ theme }) => theme.flexBox.flexMixin()}
  padding: ${({ $isMobile }) => ($isMobile ? "0 15px 42px" : "15px")};
  background-color: ${({ $isMobile, theme }) => ($isMobile ? "transparent" : theme.color.bgPrimary)};
  > button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  ${({ $isMobile }) =>
    !$isMobile &&
    `
    border-radius: 0 0 8px 8px;
  `}
`;

const CommentWrap = styled.div<{ $isMobile: boolean }>`
  position: relative;
  flex-grow: 1;

  ${({ $isMobile, theme }) =>
    $isMobile
      ? `
    margin-top: 30px;
    border-top: 1px solid ${theme.color.linePrimary};
  `
      : `
    margin-top: 32px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  `}
`;

const CommentList = styled.div`
  /* min-height: calc(100% - 55px); */
  padding: 30px 15px;
  .title {
    font-size: 16px;
    padding-bottom: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  }
  ul {
    overflow: hidden;
  }

  @media (min-width: 769px) {
    padding: 24px;

    .title {
      font-size: 18px;
      font-weight: 600;
    }
  }
`;

export default noticeDetail;
